import React from "react";
import DashboardLayout from "./DashboardLayout";
import { auth } from "./firebase";
import { useNavigate } from "react-router-dom";

function Shop() {
  const navigate = useNavigate();

  // Simplified: pass only priceId; server forces quantity=1 and reads userId from the ID token
  const handleCheckout = async (priceId) => {
    try {
      const user = auth.currentUser;
      if (!user) {
        alert("You must be logged in to purchase credits.");
        return;
      }

      // Include Firebase ID token so the function passes auth middleware
      const token = await user.getIdToken(true); // force refresh for safety

      const res = await fetch(
        "https://us-central1-cardgrader-f0ef9.cloudfunctions.net/createCheckoutSession",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ priceId }),
        }
      );

      const data = await res.json();
      if (res.ok && data.url) {
        window.location.href = data.url;
      } else {
        console.error("Checkout failed:", data);
        alert(data?.error || "Failed to create Stripe session.");
      }
    } catch (err) {
      console.error("Checkout error:", err);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <DashboardLayout>
      <h2 className="text-[2.3rem] font-bold font-[Montserrat]">Buy Credits</h2>
      <p className="text-[1.15rem] font-bold font-[Montserrat]">
        Select a quantity below to proceed to checkout.
      </p>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "16px",
          marginTop: "30px",
        }}
      >
        <button
          onClick={() => handleCheckout("price_1S0b0CCsR9mxJUAci5IdvYlq")}
          style={buttonStyle}
        >
          Buy 1 Credit – $4.49
        </button>

        <button
          onClick={() => handleCheckout("price_1S0awwCsR9mxJUAcxhFg6EWf")}
          style={buttonStyle}
        >
          Buy 5 Credits – $14.99
        </button>

        <button onClick={() => navigate("/wallet")} style={buttonStyle}>
          Back to Wallet
        </button>
      </div>
    </DashboardLayout>
  );
}

const buttonStyle = {
  width: "340px",          // widened so the $14.99 line doesn't wrap
  padding: "13.8px 27.6px",
  fontSize: "18.4px",
  fontFamily: "Montserrat",
  fontWeight: "bold",
  backgroundColor: "#1976d2",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  whiteSpace: "nowrap",     // keep text on one line
  display: "inline-flex",
  justifyContent: "center",
};

export default Shop;
